/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_Modal as Modal,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_Ro as Ro,
  rec_ii as ii,
  rec_qi as qi,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function DialogoConfirmacion(e) {
  let t = (0, ReactCompiler.c)(46),
    { dialogo: n, onCerrar: r } = e,
    {
      tipo: i,
      titulo: a,
      mensaje: o,
      peligro: s,
      opcional: c,
      confirmarTexto: l,
      cancelarTexto: u,
      placeholder: f,
    } = n,
    p = s !== void 0 && s,
    m = c !== void 0 && c,
    h = u === void 0 ? `Cancelar` : u,
    _ = f === void 0 ? `` : f,
    [v, y] = (0, React.useState)(``),
    [b, x] = (0, React.useState)(!1),
    S = i === `texto`,
    C;
  t[0] !== S || t[1] !== m || t[2] !== v
    ? ((C = S && !m && !v.trim()),
      (t[0] = S),
      (t[1] = m),
      (t[2] = v),
      (t[3] = C))
    : (C = t[3]);
  let w = C,
    T;
  t[4] !== b || t[5] !== S || t[6] !== w || t[7] !== r || t[8] !== v
    ? ((T = function (e) {
        (e?.preventDefault(), !(w || b) && (x(!0), r(!S || v.trim())));
      }),
      (t[4] = b),
      (t[5] = S),
      (t[6] = w),
      (t[7] = r),
      (t[8] = v),
      (t[9] = T))
    : (T = t[9]);
  let E = T,
    D = a ?? (p ? `Confirmá la acción` : `Confirmar`),
    O;
  t[10] !== S || t[11] !== r
    ? ((O = () => r(S ? null : !1)), (t[10] = S), (t[11] = r), (t[12] = O))
    : (O = t[12]);
  let k;
  t[13] !== o || t[14] !== p
    ? ((k = o && (
        <div
          className={`flex gap-2`}
          children={[
            p &&
              (0, JSXRuntime.jsx)(qi, {
                className: `mt-0.5 h-4 w-4 shrink-0 text-(--error)`,
              }),
            <p
              className={`whitespace-pre-wrap text-sm text-(--text-h)`}
              children={o}
            />,
          ]}
        />
      )),
      (t[13] = o),
      (t[14] = p),
      (t[15] = k))
    : (k = t[15]);
  let A;
  t[16] !== S || t[17] !== m || t[18] !== _ || t[19] !== v
    ? ((A = S && (
        <textarea
          className={`w-full rounded-2xl border border-(--border) bg-(--bg) px-3 py-2 text-sm text-(--text-h) outline-none transition duration-150 ease-(--curva) focus:border-(--accent-border) focus:ring-2 focus:ring-(--accent-bg) min-h-24`}
          value={v}
          onChange={(e) => y(e.target.value)}
          placeholder={_ || (m ? `Opcional` : `Escribí el motivo`)}
          autoFocus={!0}
        />
      )),
      (t[16] = S),
      (t[17] = m),
      (t[18] = _),
      (t[19] = v),
      (t[20] = A))
    : (A = t[20]);
  let j;
  t[21] !== S || t[22] !== r
    ? ((j = () => r(S ? null : !1)), (t[21] = S), (t[22] = r), (t[23] = j))
    : (j = t[23]);
  let M;
  t[24] !== h || t[25] !== j
    ? ((M = <button type={`button`} onClick={j} className={zo} children={h} />),
      (t[24] = h),
      (t[25] = j),
      (t[26] = M))
    : (M = t[26]);
  let N = w || b,
    P = p
      ? `rounded-full bg-(--error) px-4 py-2 text-sm font-medium text-white transition hover:opacity-90 disabled:opacity-50`
      : Ro,
    F;
  t[27] === b
    ? (F = t[28])
    : ((F =
        b &&
        (0, JSXRuntime.jsx)(ii, {
          className: `mr-1 inline h-4 w-4 animate-spin`,
        })),
      (t[27] = b),
      (t[28] = F));
  let I = l ?? (S ? `Enviar` : `Confirmar`),
    L;
  t[29] !== N || t[30] !== P || t[31] !== F || t[32] !== I
    ? ((L = (
        <button type={`submit`} disabled={N} className={P} children={[F, I]} />
      )),
      (t[29] = N),
      (t[30] = P),
      (t[31] = F),
      (t[32] = I),
      (t[33] = L))
    : (L = t[33]);
  let R;
  t[34] !== M || t[35] !== L
    ? ((R = (
        <div className={`mt-1 flex justify-end gap-2`} children={[M, L]} />
      )),
      (t[34] = M),
      (t[35] = L),
      (t[36] = R))
    : (R = t[36]);
  let z;
  t[37] !== E || t[38] !== A || t[39] !== R || t[40] !== k
    ? ((z = (
        <form
          onSubmit={E}
          className={`flex flex-col gap-3`}
          children={[k, A, R]}
        />
      )),
      (t[37] = E),
      (t[38] = A),
      (t[39] = R),
      (t[40] = k),
      (t[41] = z))
    : (z = t[41]);
  let ee;
  return (
    t[42] !== z || t[43] !== D || t[44] !== O
      ? ((ee = <Modal titulo={D} onClose={O} children={z} />),
        (t[42] = z),
        (t[43] = D),
        (t[44] = O),
        (t[45] = ee))
      : (ee = t[45]),
    ee
  );
}
